var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _c("div", [
            _c("h1", [
              _vm._v(
                "Person " +
                  _vm._s(_vm.applicant.pseudonym.label) +
                  " kontaktieren"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("main", { staticClass: "scrollbar-check" }, [
          _c(
            "div",
            [
              _c("ContactPurchase", {
                attrs: {
                  "job-profile-id": _vm.jobProfileId,
                  "job-id": _vm.jobId,
                  pseudonym: _vm.applicant.pseudonym,
                  type: "contacting",
                  initiator: "customer"
                },
                on: {
                  purchase: function($event) {
                    return _vm.close({ contacted: true })
                  }
                },
                model: {
                  value: _vm.contactData,
                  callback: function($$v) {
                    _vm.contactData = $$v
                  },
                  expression: "contactData"
                }
              })
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }